module.exports = __webpack_public_path__ + "img/Tessellate53.50af3bae.jpg";